<template>
  <div>
    <summary-form/>
  </div>
</template>

<script>
import SummaryForm from '@/components/summary-form.vue'
export default {
  name: 'SummaryView',
  components: {
    SummaryForm
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/children/summary.view.vue